import type { GibCompatibility } from "./api";

const labels = {
  compatible: "Hazır",
  review_required: "İnceleniyor",
  incompatible: "Güncelleme gerekli"
};

const pills = {
  compatible: "active",
  review_required: "partial",
  incompatible: "failed"
};

export function GibCompatibilityPanel({ data }: { data: GibCompatibility | null }) {
  return (
    <article className="panel compatibility-panel">
      <div className="panel-head">
        <div><p className="eyebrow">GİB UYUMLULUK DURUMU</p><h2>KDV iade Excel çıktıları</h2></div>
        {data && <em className={`pill ${pills[data.status]}`}>{labels[data.status]}</em>}
      </div>
      {!data ? <div className="empty-state"><p>Uyumluluk durumu yükleniyor.</p></div> : <>
        <div className="compatibility-summary">
          <strong>{data.exportable_outputs}/{data.total_outputs}</strong>
          <span><b>çıktı kullanılabilir</b><small>{data.summary}</small></span>
        </div>
        <div className="compatibility-list">
          {data.outputs.map((output) => <div className="compatibility-row" key={output.code}>
            <span><strong>{output.title}</strong><small>{output.detail}</small></span>
            <em className={`pill ${pills[output.status]}`}>{labels[output.status]}</em>
          </div>)}
        </div>
        <div className={`source-check ${data.monitoring_status}`}>
          <strong>{data.monitoring_status === "current" ? "Resmî kaynak kontrolü güncel" : "Kaynak kontrolü gecikti"}</strong>
          <small>{data.monitoring_message}</small>
          <small>{data.last_checked_at ? `Son kontrol: ${new Date(data.last_checked_at).toLocaleString("tr-TR")}` : "Henüz başarılı kaynak kontrolü yok."}</small>
        </div>
      </>}
    </article>
  );
}
